import { Mesh, Object3D } from 'three';
import traverse from './traverse-generator';

const isMesh = (obj: Object3D): obj is Mesh => Boolean(obj["isMesh"]);

export function* traverseAllMaterials (root: Object3D) {
    for(const obj of traverse(root)) {
        if(isMesh(obj)) {
            if(Array.isArray(obj.material)) {
                yield * obj.material;
            } else {
                yield obj.material;
            }
        }
    }

};
